import {useSelector,useDispatch} from 'react-redux'

import {updateAppSettings} from '../../settings/settingsSlice'

import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'

export default function Settings(){
	const dispatch = useDispatch()

	const {default_subscription_billing_anchor} = useSelector(
		state => state.settings.app
	)

	const updateBillingAnchor = (value) => {
		dispatch(updateAppSettings({
			default_subscription_billing_anchor:value
		}))
	}

	return (
		<div className="p-1">
			<div className="mb-2">
				<i className="fa fa-info-circle mr-1"/>
				Default start date for subscriptions. For example you can specify that all subscriptions should be charged on the 1st. This is only available for monthly subscriptions.
			</div>
			<div>
				{default_subscription_billing_anchor>0&&
					<>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text>
									<i className="fa fa-calendar"/>
								</InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control
								onChange={e=>{
									const newValue = Math.min(
										Math.max(
											parseInt(e.target.value) || 1,
											1
										),
										28
									)
									updateBillingAnchor(newValue)
								}}
								defaultValue={default_subscription_billing_anchor}
								min="0"
								max="28"
								type="number"
								placeholder="Subscription start date (1-28)"
							/>
						</InputGroup>
						<div>
							<small>Enter a number 1-28</small>
						</div>
					</>
				}
				<Form.Check
					onChange={e=>{
						const newValue = (
							e.target.checked
							? 0
							: 1
						)
						updateBillingAnchor(newValue)
					}}
					checked={default_subscription_billing_anchor===0}
					label="Start subscription charges immediately"
					id="charge-immediately"
				/>
			</div>
		</div>
	)
}